import { render } from "./explore-housing.vue?vue&type=template&id=5b488008"
import script from "./explore-housing.vue?vue&type=script&lang=js"
export * from "./explore-housing.vue?vue&type=script&lang=js"

import "./explore-housing.vue?vue&type=style&index=0&id=5b488008&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__